import { useState } from "react";
import { compareIds, when } from "util/support";
import type { PaymentMethod } from "features/paymentMethods/types";

export const usePaymentMethods = () => {
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>();

    const comparePaymentMethods = (
        method: PaymentMethod,
        prevMethod?: PaymentMethod
    ) => compareIds(`${prevMethod?.tag}`, method.tag);

    const togglePaymentMethod = (method: PaymentMethod) => (
        setPaymentMethod(prevMethod =>
            when(
                !comparePaymentMethods(method, prevMethod),
                method
            )
        )
    );

    const resetPaymentMethod = () => setPaymentMethod(undefined);

    return {
        paymentMethod,
        togglePaymentMethod,
        comparePaymentMethods,
        resetPaymentMethod
    };
};

export default usePaymentMethods;
